<template>
  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20.0345 6.53629L14.0671 0.966797L8.09961 6.53629"
      stroke="#040A34"
      stroke-width="0.942229"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19.166 5.8335V11.7536C19.166 12.166 18.8217 12.5002 18.3968 12.5002H9.93525C9.51037 12.5002 9.16602 12.166 9.16602 11.7536V5.8335"
      stroke="#040A34"
      stroke-width="0.942229"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.1673 3.16699L8.83398 5.83366L9.16732 11.8337L9.83398 12.5003H18.834C18.9451 12.3892 19.1673 11.967 19.1673 11.167V5.50033C19.1673 5.23366 15.834 2.50033 14.1673 1.16699L12.1673 3.16699ZM13.5003 10.2982V10.8372C13.5004 11.2054 13.7992 11.5042 14.1673 11.5042C14.5355 11.5042 14.8342 11.2054 14.8343 10.8372V10.2982H15.6673C16.0354 10.2982 16.3341 10.0001 16.3343 9.63217V7.6683C16.3341 7.30026 16.0354 7.00229 15.6673 7.00229H13.3343V6.37241H15.6673L15.8021 6.35873C16.1057 6.29643 16.3343 6.02745 16.3343 5.70541C16.3343 5.33727 16.0355 5.03842 15.6673 5.03842H14.8343V4.50034C14.8343 4.13215 14.5355 3.83335 14.1673 3.83334C13.7991 3.83334 13.5003 4.13215 13.5003 4.50034V5.03842H12.6673C12.2992 5.03842 12.0004 5.33727 12.0003 5.70541V7.6683C12.0003 8.03649 12.2991 8.3353 12.6673 8.3353H15.0003V8.96518H12.6673C12.2991 8.96518 12.0003 9.26398 12.0003 9.63217C12.0006 10.0001 12.2993 10.2982 12.6673 10.2982H13.5003Z"
      fill="#040A34"
    />
    <path
      d="M4.48667 12.4667C5.74667 12.48 6.92 12.6267 8.04667 13.0534C9.17333 13.48 10.3467 13.4467 11.52 13.4267C12.9067 13.4 13.32 13.7067 13.7267 15.06C15 14.5067 16.2667 13.9467 17.54 13.4067C18.06 13.18 18.62 13.0734 19.16 13.3C19.48 13.4334 19.8 13.62 20.04 13.8667C20.6867 14.5334 20.66 15.22 19.96 15.8267C19.4333 16.28 18.88 16.7 18.2933 17.0734C17.0933 17.8334 15.88 18.5667 14.6533 19.2867C12.4533 20.5734 10.1467 20.8134 7.70667 20.0134C6.69333 19.68 5.61333 19.5267 4.56667 19.2867C4.32667 20.3867 4.2 20.4867 3.15333 20.4867C2.6 20.4867 2.04 20.4934 1.48667 20.4867C0.826667 20.48 0.506667 20.18 0.506667 19.5334C0.5 16.8134 0.5 14.1134 0.5 11.4067C0.5 10.8 0.806667 10.4867 1.4 10.4734C2.12667 10.46 2.85333 10.46 3.58 10.4734C4.16667 10.48 4.47333 10.8067 4.48667 11.4067C4.49333 11.7467 4.48667 12.0867 4.48667 12.4667Z"
      fill="#040A34"
    />
  </svg>
</template>
